"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const snap_ui_1 = require("@teamsnap/snap-ui");
const useAmpli_1 = require("hooks/useAmpli");
const useExperiments_1 = require("hooks/useExperiments");
const useNavigation_1 = require("hooks/useNavigation");
const React = __importStar(require("react"));
const layouts_1 = require("../shared/layouts");
const layouts_2 = require("../shared/layouts");
const useInvitation_1 = require("./useInvitation");
const TsPlusOffer = () => {
    const [selectedPlan, setSelectedPlan] = React.useState('yearly');
    const { rosterFirstName, teamSport, offers, continueInviteClassic, isProcessing, invitationLoading, invitationLoadError, loadOffers, loadOffersError, checkout, checkoutError, newUser, invitationCode, } = React.useContext(useInvitation_1.InvitationContext);
    const { navigate } = (0, useNavigation_1.useNavigation)();
    const experiments = (0, useExperiments_1.useExperiments)();
    const inviteOffersNew = experiments[useExperiments_1.EXPERIMENT_IDS.INVITE_OFFERS_NEW];
    const forwardToNewOffersPage = inviteOffersNew
        ? Boolean(inviteOffersNew?.isEnabled && inviteOffersNew?.hasAccess)
        : false;
    React.useEffect(() => {
        if (forwardToNewOffersPage && invitationCode) {
            navigate.v1InviteTsPlusOfferNew(invitationCode, { newUser });
        }
    }, [forwardToNewOffersPage, invitationCode, navigate]);
    const { screenViewed, onboardingButtonClicked } = (0, useAmpli_1.useAmpli)();
    const PLANS = [
        {
            id: offers?.monthly?.id ?? '',
            type: 'monthly',
            price: offers?.monthly?.priceInCents ? `$${offers?.monthly?.priceInCents / 100} / mo` : '',
            trial: offers?.monthly?.trialLengthInDays ? `${offers?.monthly?.trialLengthInDays}-day free trial` : '',
        },
        {
            id: offers?.annual?.id ?? '',
            type: 'yearly',
            price: offers?.annual?.priceInCents ? `$${offers?.annual?.priceInCents / 100} / yr` : '',
            trial: offers?.annual?.trialLengthInDays ? `${offers?.annual?.trialLengthInDays}-day free trial` : '',
            badgeLabel: offers?.annual?.saveDescription,
        },
    ];
    const isTrialEligible = !!offers?.monthly?.trialLengthInDays;
    const SUBSCRIPTION_BENEFITS = [
        `1:1 drills for ${rosterFirstName} to boost skills and have more fun playing!`,
        'Practice plans customized to sport, age and skill level',
        'Expert-curated drills from Major League Soccer, FC Barcelona, MLB, NBA and more',
        'Premium ad-free experience',
    ];
    const onDecline = () => {
        onboardingButtonClicked('Skip TS+', useAmpli_1.AmplitudeScreenNames.TS_PLUS_OFFER);
        continueInviteClassic();
    };
    const onCheckout = async () => {
        const priceId = PLANS.find((p) => p.type === selectedPlan)?.id;
        onboardingButtonClicked('Start TS+', useAmpli_1.AmplitudeScreenNames.TS_PLUS_OFFER);
        await checkout(priceId ?? '');
    };
    const error = invitationLoadError || loadOffersError || checkoutError;
    React.useEffect(() => {
        if (!invitationLoading && !offers) {
            loadOffers().then((data) => {
                if (!data) {
                    continueInviteClassic();
                }
                else {
                    screenViewed(useAmpli_1.AmplitudeScreenNames.TS_PLUS_OFFER);
                }
            });
        }
        else if (!invitationLoading && offers) {
            // If we've already loaded the offers by way of useInvitation
            screenViewed(useAmpli_1.AmplitudeScreenNames.TS_PLUS_OFFER);
        }
    }, [invitationLoading]);
    if ((isProcessing && !offers) || invitationLoading || (!offers && !error) || forwardToNewOffersPage) {
        return React.createElement(layouts_2.LoadingPageBlank, null);
    }
    if (error) {
        return (React.createElement(layouts_1.InvitePageWrapper, null,
            React.createElement("div", { "data-testid": "loading-error" }, "Something went wrong")));
    }
    return (React.createElement(layouts_1.InvitePageWrapper, null,
        React.createElement(layouts_1.InviteHeader, { className: "sui-mb-1", headerText: `Ready to help ${rosterFirstName} have the best season ever?` }),
        React.createElement("div", { className: "sui-block sui-w-full invite-form" },
            React.createElement("p", { className: "sui-body sui-text-center sui-mb-3" },
                "Get fun, effective ",
                teamSport?.toLowerCase(),
                " training videos \u2013 and more \u2013 with TeamSnap+."),
            React.createElement("p", { className: "sui-body sui-mb-3" }, "With a TeamSnap+ subscription you'll get:"),
            React.createElement("ul", { className: "sui-pl-0 sui-mb-4" }, SUBSCRIPTION_BENEFITS.map((benefit, index) => (React.createElement("li", { className: "sui-flex sui-items-center sui-mb-2", key: index },
                React.createElement(snap_ui_1.Icon, { name: "check", className: "sui-text-green-40 sui-mr-2" }),
                React.createElement("span", null, benefit))))),
            React.createElement("div", { className: "sui-flex sui-flex-row sui-gap-2 sui-mb-4" }, PLANS.map((v) => (React.createElement(snap_ui_1.BorderedRadio, { "data-testid": `plan-${v.type}`, size: "card", selected: selectedPlan === v.type, className: "sui-relative sui-flex-1", onSelect: () => {
                    setSelectedPlan(v.type);
                }, key: v.type },
                React.createElement("div", { className: "sui-pt-1 sui-ml-1" },
                    React.createElement("div", { className: "sui-text-desktop-8 sui-font-bold" }, v.price),
                    v.trial && React.createElement("div", { className: "sui-text-gray-40" }, "7-day free trial"),
                    v.badgeLabel && (React.createElement("div", { className: "sui-absolute sui-mt-1 sui-mr-2 [top:0] [right:0]" },
                        React.createElement("div", { className: "sui-px-1 sui-my-0.5 sui-text-skyblue-30 sui-font-semibold sui-bg-skyblue-90 sui-rounded-[10px]" }, v.badgeLabel)))))))),
            React.createElement(snap_ui_1.LabelButton, { "data-testid": "checkout-button", className: "sui-min-w-full sui-mb-2", labelText: isTrialEligible ? 'Try it risk-free for a week' : 'Buy', onClick: onCheckout, disabled: !selectedPlan || isProcessing, variantType: "primary" }),
            React.createElement(snap_ui_1.LabelButton, { "data-testid": "decline-button", className: "sui-min-w-full", labelText: "No thanks", onClick: onDecline, variantType: "tertiary" }))));
};
exports.default = TsPlusOffer;
